import VwoScript from "./vwoScript";

export default VwoScript;